export default "__VITE_ASSET__D0gnXi_t__"